<!-- breadcrumb  -->

<div class="breadcrumb-container with-title-nav pt-4">
  <div class="title-nav-wrapper">
    <h4 class="breadcrumb-title">Video Library</h4>
    <nav class="breadcrumb-nav">
      <a routerLink="/" class="breadcrumb-link">Home</a>
      <span class="breadcrumb-separator">></span>

      @if (isVideoLibraryRoute) {
      <span class="breadcrumb-current">Video Library</span>
      } @else {
      <a routerLink="/video-library" class="breadcrumb-link">Video Library</a>
      }
    </nav>
  </div>
</div>

<!-- Show single video if selected -->
@if (selectedVideo) {
<div class="d-flex justify-content-center px-2">
  <mat-card class="w-75">
    <div class="video-wrapper" style="height: 100vh;">
      <app-video-card [video]="selectedVideo" [index]="999" [isHomePage]="singleVideo"></app-video-card>
      <!-- <iframe #videoIframe [src]="selectedVideo.iframe_AutoPlay | safeUrl" frameborder="0" allowfullscreen
        allow="autoplay" title="{{ selectedVideo.title }}"
      style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; border: none;"></iframe> -->
    </div>
  </mat-card>
  <mat-card class="w-25">
    <mat-card-header>
      <mat-card-title>{{ selectedVideo.title }}</mat-card-title>
    </mat-card-header>
    <mat-card-content class="mt-3 px-3">
      <div class="d-flex justify-content-between align-items-start flex-wrap">
        <div>
          <p><strong>Category:</strong> {{ selectedVideo.category }}</p>
          <p><strong>Duration:</strong> {{ selectedVideo.duration }}</p>
          <p><strong>Uploaded:</strong> {{ selectedVideo.upload_date | date }}</p>
          <p><strong>Description:</strong> {{ selectedVideo.description }}</p>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>
} @else {
<div class="container">
  <!-- Search and Category Row -->
  <div class="d-flex align-items-center justify-content-between flex-wrap mb-3 gap-2">
    <!-- Search Box -->
    <div class="table-search">
      <input
        class="report-search-option table-data-font search-box repo-search"
        [(ngModel)]="searchQuery"
        placeholder="Search videos by categories"
      />
      <img class="search_Icon" src="../../../../assets/images/searchicon.png" style="margin-left: -25px;" />
    </div>
    <!-- Category Chips -->
    <div class="category-chip-wrapper d-flex flex-wrap gap-2" style="flex: 2;">
      @for (category of categories; track category) {
      <div
        class="category-chip"
        [ngClass]="{
          'bg-primary text-white': selectedCategory === category,
          'bg-light text-dark': selectedCategory !== category
        }"
        (click)="selectCategory(category)"
      >
        {{ category }}
      </div>
      }
    </div>
  </div>
  <!-- Video Grid -->
  <div class="row">
    @for (video of filteredVideos; track trackByVideo(i, video); let i = $index) {
    <div class="col-md-4 mb-4">
      <app-video-card [video]="video" [index]="i" [isHomePage]="'library'"></app-video-card>
    </div>
    }
  </div>
</div>
}
